var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "vapp",
      attrs: { id: "vapp" },
      on: {
        drop: function ($event) {
          $event.preventDefault()
          return _vm.handleDesktopDrop.apply(null, arguments)
        },
        dragover: function ($event) {
          $event.preventDefault()
          return _vm.handleDragOver.apply(null, arguments)
        },
        dragenter: function ($event) {
          $event.preventDefault()
          return _vm.handleDragEnter.apply(null, arguments)
        },
        dragleave: function ($event) {
          $event.preventDefault()
          return _vm.handleDragLeave.apply(null, arguments)
        },
      },
    },
    [
      _c("div", { staticClass: "apphead" }, [
        _c("div", { staticClass: "topnav" }, [
          _c(
            "a",
            {
              staticClass: "applogo",
              class: { error: _vm.errorStatus },
              attrs: { title: _vm.applicationName },
            },
            [
              _vm._v(
                _vm._s(_vm.userMessage) + " [" + _vm._s(_vm.user.name) + "]"
              ),
            ]
          ),
          _vm.showMenu
            ? _c("div", { attrs: { id: "menuEntries" } }, [
                _c("a", { on: { click: _vm.onShowLog } }, [
                  _c("i", { staticClass: "fa fa-terminal" }),
                  _vm._v("  " + _vm._s(_vm.showLogMsg())),
                ]),
                _c("a", { on: { click: _vm.onChangePassword } }, [
                  _c("i", { staticClass: "fa fa-key" }),
                  _vm._v("  " + _vm._s(_vm.$t("menu.CHANGE_PWD"))),
                ]),
                _c("a", { on: { click: _vm.onLogout } }, [
                  _c("i", { staticClass: "fa fa-sign-out" }),
                  _vm._v("  " + _vm._s(_vm.$t("menu.LOGOUT"))),
                ]),
              ])
            : _vm._e(),
          _c(
            "a",
            {
              staticClass: "icon",
              attrs: { href: "javascript:void(0);" },
              on: { click: _vm.onHamburgerClick },
            },
            [_c("i", { staticClass: "fa fa-bars" })]
          ),
          _c(
            "a",
            {
              staticClass: "icon",
              class: [_vm.isOnline() ? "online" : "offline"],
              attrs: { href: "#", title: _vm.isOnlineMsg() },
            },
            [_c("i", { staticClass: "fa fa-signal" })]
          ),
        ]),
      ]),
      _c("div", { staticClass: "appbody" }, [
        _c("div", { staticClass: "appbodybody" }, [
          _c("div", { staticClass: "wrapper appbodybodywrapper" }, [
            _c(
              "div",
              { staticClass: "projectscontainer bluerectcontainer" },
              [
                _c("div", { staticClass: "appbodytoolbar" }, [
                  _c(
                    "div",
                    { staticClass: "hwrapper" },
                    [
                      _c("h2", { staticClass: "wrapped" }, [
                        _vm._v(_vm._s(_vm.$t("prj.TITLE"))),
                      ]),
                      _c("buttonstoolbar", {
                        attrs: { buttons: _vm.projectButtons },
                      }),
                    ],
                    1
                  ),
                ]),
                _c("multiselect", {
                  attrs: {
                    columns: ["name", "lastSentDate", "numRecsToBeSent"],
                    items: _vm.projects,
                    tooltip: _vm.onProjectTooltip,
                  },
                  on: { "item-selected": _vm.onProjectSelected },
                }),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "filescontainer bluerectcontainer" },
              [
                _c("div", { staticClass: "largetoolbar" }, [
                  _c(
                    "div",
                    { staticClass: "hwrapper" },
                    [
                      _c("h2", { staticClass: "wrapped" }, [
                        _vm._v(_vm._s(_vm.$t("file.TITLE"))),
                      ]),
                      _c("buttonstoolbar", {
                        attrs: { buttons: _vm.fileButtons },
                        on: { "toolbar-drop": _vm.onFileToolbarDrop },
                      }),
                    ],
                    1
                  ),
                ]),
                _c("multiselect", {
                  ref: "files",
                  attrs: {
                    options: { select: "multi", canDrag: true },
                    items: _vm.filesArray,
                    tooltip: _vm.onFileTooltip,
                  },
                  on: {
                    "item-selected": _vm.onFileSelected,
                    "item-drag-start": _vm.onFileDragStart,
                    "item-drag-end": _vm.onFileDragEnd,
                  },
                }),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "filepreviewcontainer bluerectcontainer" },
              [
                _c("div", { staticClass: "appbodytoolbar" }, [
                  _c("div", { staticClass: "hwrapper" }, [
                    _c("h2", { staticClass: "wrapped" }, [
                      _vm._v(
                        "\n                " +
                          _vm._s(_vm.$t("preview.TITLE")) +
                          "\n              "
                      ),
                    ]),
                  ]),
                ]),
                _c("preview", { attrs: { file: _vm.previewFile } }),
              ],
              1
            ),
          ]),
        ]),
      ]),
      _vm.showLog
        ? _c("div", { staticClass: "apptail" }, [
            _c("div", { staticClass: "appbodytoolbar" }, [
              _c("div", { staticClass: "configscontainer wrapper" }, [
                _c("h2", { staticClass: "wrapped" }, [
                  _vm._v(_vm._s(_vm.$t("log.TITLE"))),
                ]),
              ]),
            ]),
            _c("div", {
              staticClass: "log bluerect",
              domProps: { innerHTML: _vm._s(_vm.fullLog) },
            }),
          ])
        : _vm._e(),
      _c("editor", {
        ref: "edt",
        attrs: { editFileData: _vm.editFileData },
        on: { onSave: _vm.onSaveFileData },
      }),
      _c("prjeditor", {
        ref: "prjedt",
        attrs: { editProjectData: _vm.editProjectData },
        on: { onSave: _vm.onSaveProjectData },
      }),
      _c("dropper", {
        ref: "drp",
        attrs: { selectedProject: _vm.getSelectedProject() },
        on: { onDrop: _vm.onDrop, onDropComplete: _vm.onDropComplete },
      }),
      _c("div", { staticStyle: { display: "none" }, attrs: { id: "utility" } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }